import funfairevents_background from "../images/funfairevents/funfairevents_background.png";
import '../invitations/Invitation.css'

const funfaireventsInvitationElements = [

  // 🌌 BACKGROUND
  {
    id: 13,
    type: "background",
    src: funfairevents_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  // 🎡 TOP ICONS
  {
    id: 1,
    type: "text",
    text: "🎡",
    x: 150,
    y: 50,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },
  {
    id: 2,
    type: "text",
    text: "🎪",
    x: 510,
    y: 50,
    fontSize: 30,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // TAGLINE
  {
    id: 3,
    type: "text",
    text: "Fun • Games • Smiles",
    x: 130,
    y: 100,
    fontSize: 18,
    fontFamily: "Great Vibes",
    fill: "#fafaf9"
  },

  // MAIN TITLE
  {
    id: 4,
    type: "text",
    text: "FUN FAIR EVENT",
    x: 185,
    y: 50,
    fontSize: 30,
    fontFamily: "Playfair Display",
    fill: "#fafaf9"
  },

  // DIVIDER
  {
    id: 5,
    type: "text",
    text: "──────── ✦ ────────",
    x: 130,
    y: 120,
    fontSize: 12,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // DESCRIPTION
  {
    id: 6,
    type: "text",
    text: "Join us for a day full of exciting rides, games, food, and family fun",
    x: 18,
    y: 150,
    fontSize: 9,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // DATE
  {
    id: 7,
    type: "text",
    text: "📅 Date: 22 November 2026",
    x: 30,
    y: 180,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // TIME
  {
    id: 8,
    type: "text",
    text: "⏰ Time: 4:00 PM",
    x: 70,
    y: 200,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // VENUE
  {
    id: 9,
    type: "text",
    text: "📍 Venue:",
    x: 330,
    y: 150,
    fontSize: 20,
    fontFamily: "Playfair Display",
    fill: "#fafaf9"
  },

  {
    id: 10,
    type: "text",
    text: "City Fun Grounds",
    x: 335,
    y: 170,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  {
    id: 11,
    type: "text",
    text: "Vijayawada",
    x: 355,
    y: 190,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#fafaf9"
  },

  // FOOTER
  {
    id: 12,
    type: "text",
    text: "Laugh • Play • Celebrate",
    x: 90,
    y: 280,
    fontSize: 24,
    fontFamily: "Great Vibes",
    fill: "#fafaf9"
  }

];

export default funfaireventsInvitationElements;